@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if (
    $.row[$.adata.keyName] && $.row[$.adata.keyName] != '01/01/0001 00:00:00'
  ) {
    <span>
      {{ getDate($.row[$.adata.keyName]) | date: $.adata.format }}
    </span>
  } @else {
    -
  }
}
